/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Role
 */
export type RoleRecordItem = {
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Role name
     */
    roleName?: string;
    /**
     * Role Key - Unique
     */
    roleKey?: string;
    /**
     * Role name
     */
    roleDescription?: string;
    /**
     * Rank - Higher is more privileged
     */
    roleRank?: number;
    /**
     * Role Scope Type - e.g. 'GLOBAL', 'TENANT'
     */
    scopeType?: RoleRecordItem.scopeType;
    /**
     * ID if Scope Type is 'TENANT' or 'CUSTOMER'
     */
    scopeId?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * createdBy Unique ID
     */
    createdBy?: number;
    /**
     * updatedBy Unique ID
     */
    updatedBy?: number;
    /**
     * Flag for record being active
     */
    active?: boolean;
    /**
     * Flag for Role being System Role
     */
    isSystem?: boolean;
    /**
     * API Response Version
     */
    _ver?: number;
}

export namespace RoleRecordItem {

    /**
     * Role Scope Type - e.g. 'GLOBAL', 'TENANT'
     */
    export enum scopeType {
        GLOBAL = 'GLOBAL',
        TENANT = 'TENANT',
        CUSTOMER = 'CUSTOMER',
    }


}
